import {connect} from 'react-redux';
import ScholarshipCTA from 'shared/college-profile/components/scholarship-cta';

const mapStateToProps = (state) => ({collegeProfile: state.collegeProfile});

export default connect(mapStateToProps)(ScholarshipCTA);
